/**
 * Hints page composable - matches original script.js exactly
 * Keeps all data and methods in one place to avoid mismatches
 */
import { ref, reactive, onMounted } from '@vue/composition-api';
import axios from 'axios';
import { getters, mutations } from "@/components/game/store";
import { bannerProps } from "@/components/game/shared/baseBanner";
import { HOST_URL, API_V1, API_V2 } from '@/config/api';
import { useTutorial } from '../../composables/tutorial';

export function useHintsPage(props) {
  // Tutorial integration
  const tutorial = useTutorial('hints', {
    memberLineId: props.memberLineId,
    groupId: props.groupId
  });
  // Data - matching script.js data()
  const allHints = ref([]);
  const story_id = ref('');

  const icon = reactive({
    hintBlock: '',
    unlockBlock: '',
    locked: ''
  });

  const background = reactive({
    mainBg: ''
  });

  const bannerPropsRef = reactive({ ...bannerProps });

  // Methods - matching script.js methods
  const initViewData = () => {
    const topicInfo = getters.getTopicInfo('hint');
    bannerPropsRef.imgSrc = topicInfo.banner;
    bannerPropsRef.content = sampleContent(topicInfo.banner_content);
    bannerPropsRef.styles = "top: 50px; left: 155px;";
    bannerPropsRef.banner_avatar = topicInfo.banner_avatar;
    icon.hintBlock = topicInfo.unlocked;
    icon.unlockBlock = topicInfo.unlocked_background;
    icon.locked = topicInfo.locked;
    background.mainBg = topicInfo.background;
  };

  const sampleContent = (contents) => {
    if (!contents || !contents.length) return '';
    return contents[Math.floor(Math.random() * contents.length)];
  };

  const init = (data) => {
    story_id.value = data.group && data.group.story_id;
    allHints.value = data.hints || allHints.value;
  };

  const revealOneHint = () => {
    axios
      .get(`${HOST_URL}${API_V1}/line/hint?group_id=${props.groupId}&story_id=${story_id.value}`)
      .then((response) => {
        setHintResult(response.data);
        // Advance tutorial if waiting for unlock-hint action
        advanceTutorialOnUnlockHint();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * Helper to advance tutorial when user unlocks a hint
   */
  const advanceTutorialOnUnlockHint = () => {
    if (tutorial.isActive.value &&
        tutorial.currentStep.value &&
        tutorial.currentStep.value.waitForAction === 'unlock-hint') {
      setTimeout(() => {
        tutorial.nextStep();
      }, 300);
    }
  };

  const changeLine = (content) => {
    var temp_content = "";
    if (content) {
      content.split("\n").forEach(function (e) {
        temp_content = temp_content + e + "<br>";
      });
      return temp_content;
    }
  };

  const setHintResult = (data) => {
    allHints.value.find((hint) => hint.id == data.hint.id).is_used = true;
    allHints.value.find((hint) => hint.id == data.hint.id).content = data.hint.report;
  };

  const onLoaded = () => {
    mutations.closeLoading();
  };

  // Lifecycle - matching script.js created
  onMounted(async () => {
    initViewData();
    try {
      // Try v2 API first (includes tutorial info)
      const response = await axios.get(
        `${HOST_URL}${API_V2}/groups/${props.groupId}/hints?line_id=${props.memberLineId}`
      );
      init(response.data);

      // Initialize tutorial from API response
      tutorial.initFromApiResponse(response.data);
    } catch (error) {
      // Fallback to v1 API
      try {
        const response = await axios.get(
          `${HOST_URL}${API_V1}/line/hints?group_id=${props.groupId}`
        );
        init(response.data);
      } catch (fallbackError) {
        console.log(`遊戲服務中斷: ${fallbackError.message}`);
      }
    }
  });

  // Return everything the template needs - matching script.js exactly
  return {
    // Data
    allHints,
    story_id,
    icon,
    background,
    bannerProps: bannerPropsRef,

    // Methods
    initViewData,
    sampleContent,
    init,
    revealOneHint,
    changeLine,
    setHintResult,
    onLoaded,

    // Tutorial
    tutorial
  };
}
